import React from 'react'
import './css/App.css'

function TypeDescriber(props) {
    const location = props.location;
    const parts = location.split('/');
    const remaining = parts.slice(1).join(' ~ ');
    return (
        <div className='categoryHeading' >
            <p>{remaining}</p>

        </div>
    )
}

export default TypeDescriber